import React from 'react';

export default React.createContext<{ token: string; isFirebaseReady: boolean } | undefined>(undefined);
